import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useFeature } from '@ole-ui/ole-ui-components';
import { storesContext } from 'stores';
import { PRODUCT_TRIAL_PAGE } from 'config/constants';

import { LandingLayout } from 'components/Landing/LandingLayout';
import { EnablementFeatureFlags } from 'config/featureFlags';

import './styles.scss';
import { CardTitle } from '@patternfly/react-core';

interface ExploreSubscriptionsProps {
  className?: string;
  isRHLSTrialCopy?: boolean;
}

const ExploreSubscriptions: React.FC<ExploreSubscriptionsProps> = ({
  className,
  isRHLSTrialCopy,
}) => {
  const { t } = useTranslation();
  const { userStore } = useContext(storesContext);
  const { enablementsConfigurations } = userStore;
  const subscriptionUnlockUrl =
    (enablementsConfigurations?.subscription_to_unlock_url ||
      PRODUCT_TRIAL_PAGE) as string;
  const showComponent = useFeature({
    section: 'enablements',
    flagName: EnablementFeatureFlags.ShowHowToBuy,
    defaultFlagValue: false,
  });

  if (showComponent) {
    return (
      <div className={classNames('explore-subscriptions', className)}>
        {isRHLSTrialCopy ? (
          <>
            <CardTitle>{t('Subscribe')}</CardTitle>
            <p>
              {t(
                'Upgrade your subscription to enjoy full offerings and exclusive features. See the difference and choose the plan that suits you best.',
              )}
            </p>
          </>
        ) : (
          <p>{t('Level up your learning.')}</p>
        )}
        <a href={subscriptionUnlockUrl} target="_blank" rel="noreferrer">
          <LandingLayout.ExploreButton isBlock>
            {t('Compare plans')}
          </LandingLayout.ExploreButton>
        </a>
      </div>
    );
  }

  return null;
};

export default ExploreSubscriptions;
